"use client";

import useIdleReady from "@/hooks/useIdleReady";
import dynamic from "next/dynamic";

const DelegatedClickTracking = dynamic(
  () => import("@/components/DelegatedClickTracking"),
  { loading: () => null }
);
const LetzChatScript = dynamic(() => import("@/components/LetzChatScript"), {
  loading: () => null,
});

interface DeferredGlobalClientWorkProps {
  translationUrl?: string;
}

export default function DeferredGlobalClientWork({
  translationUrl,
}: DeferredGlobalClientWorkProps) {
  const isIdleReady = useIdleReady();

  if (!isIdleReady) {
    return null;
  }

  return (
    <>
      <LetzChatScript url={translationUrl} />
      <DelegatedClickTracking />
    </>
  );
}
